import { Box, Divider, FormControl } from "@material-ui/core";
import { FmcsaInspectionDto } from "../../../common/data/service-proxies";
import { GetApp, VerifiedUser } from "@material-ui/icons";
import { Button, useNotify, useRefresh } from "react-admin";
import { MarkFmcsaInspectionUnofficialDialog } from "./MarkFmcsaInspectionUnofficialDialog";
import { useState } from "react";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import permissionNames from "../../../common/auth/access-control/permissionNames";

interface Props {
  record?: FmcsaInspectionDto;
}

export const ViewFmcsaDataTransferActions = ({ record }: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState<boolean>(false);
  const permissions = useActionPermissions();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  if (!record) {
    return null;
  }

  return (
    <>
      <Divider />
      <FormControl margin="dense">
        <Box display="flex">
          <Button
            component="a"
            href={record?.eldFileUrl ?? undefined}
            label="Download ELD file"
          >
            <GetApp />
          </Button>
          {permissions &&
          permissions[permissionNames.hos.fmcsaDataTransfer.markUnofficial] &&
          !record.isUnofficial ? (
            <Button
              label="Mark unofficial"
              onClick={() => setConfirmOpen(true)}
            >
              <VerifiedUser />
            </Button>
          ) : null}
        </Box>
      </FormControl>
      <MarkFmcsaInspectionUnofficialDialog
        isOpen={isConfirmOpen}
        onClose={handleDialogClose}
        onSuccess={() => {
          notify(
            "resources.fmcsa-data-transfer.notifications.markedUnofficial",
            {
              type: "success",
            }
          );

          handleDialogClose();
          refresh();
        }}
        record={record}
      />
    </>
  );
};
